module.exports = __webpack_public_path__ + "img/support_b3.8387032d.png";